module.exports = __webpack_public_path__ + "img/despacho01.07fc3dab.png";